import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Heart, BookOpen, Globe, Feather } from 'lucide-react';
import { Language } from '../App';
interface AboutSectionProps {
  language: Language;
}
export function AboutSection({
  language
}: AboutSectionProps) {
  const isPashto = language === 'pashto';
  const pillars = isPashto ? [{
    icon: BookOpen,
    title: 'لیکلې پښتو ټولو ته ورسوو',
    description: 'د پښتو لیکلو او لوستلو وړتیا هر پښتون ته ورسول.'
  }, {
    icon: Globe,
    title: 'ادبي اثار خوندي او خپاره کړو',
    description: 'د پښتو شاعرۍ، ادب او علمي لیکنو ساتنه او خپرول.'
  }, {
    icon: Feather,
    title: 'راتلونکو نسلونو ته د ژبې مینه وسپارو',
    description: 'د ژبې مینه او پیژندنه نویو نسلونو ته لېږدول.'
  }] : [{
    icon: BookOpen,
    title: 'Bring Written Pashto to All',
    description: 'Making Pashto literacy accessible to every Pashtun, everywhere.'
  }, {
    icon: Globe,
    title: 'Preserve & Share Literary Works',
    description: 'Safeguarding Pashto poetry, literature, and scholarly writing for the world.'
  }, {
    icon: Feather,
    title: 'Pass the Love of Language Forward',
    description: 'Inspiring future generations to cherish and carry forward their mother tongue.'
  }];
  return <section className="relative py-10 md:py-14 px-6 overflow-hidden text-start" data-id="element-33">
      {/* Soft background tint */}
      <div className="absolute inset-0 bg-gradient-to-b from-pasoon-green/40 via-white to-white pointer-events-none" data-id="element-34"></div>
      <div className={`absolute top-0 w-[400px] h-[400px] bg-pasoon-green/30 rounded-full blur-[120px] pointer-events-none -translate-y-1/2 ${isPashto ? 'left-0 -translate-x-1/4' : 'right-0 translate-x-1/4'}`} data-id="element-35"></div>

      <div className="relative z-10 max-w-5xl mx-auto" data-id="element-36">
        <AnimatePresence mode="wait" data-id="element-37">
          <motion.div key={language} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -20
        }} transition={{
          duration: 0.4
        }} data-id="element-38">
            {/* Our Goals heading */}
            <h3 className={`text-xl md:text-2xl font-bold text-pasoon-dark mb-6 ${isPashto ? 'font-pashto' : 'font-serif'}`} data-id="element-39">
              {isPashto ? 'زموږ موخه دا ده چې:' : 'Our Mission:'}
            </h3>

            {/* Mission Pillars */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 items-stretch" data-id="element-40">
              {pillars.map((pillar, idx) => <div key={pillar.title} className="text-start flex flex-col h-full" data-id="element-41">
                  <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-pasoon-red/10 mb-4" data-id="element-42">
                    <pillar.icon className="w-5 h-5 text-pasoon-red" data-id="element-43" />
                  </div>
                  <h3 className={`text-lg font-bold text-pasoon-dark mb-2 ${isPashto ? 'font-pashto' : 'font-serif'}`} data-id="element-44">
                    {pillar.title}
                  </h3>
                  <p className={`text-gray-500 text-sm md:text-base flex-grow ${isPashto ? 'font-pashto leading-loose' : 'leading-relaxed'}`} data-id="element-45">
                    {pillar.description}
                  </p>
                </div>)}
            </div>
          </motion.div>
        </AnimatePresence>
      </div>
    </section>;
}